
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import HeaderCard from '../../mui-components/Cards/HeaderCard';
import FunnelItem from '../../mui-components/Cards/FunnelItem';
import KanbanContainer from '../../mui-components/Kanban/KanbanContainer';
import KanbanColumn from '../../mui-components/Kanban/KanbanColumn';
import KanbanCard from '../../mui-components/Kanban/KanbanCard';

import sanitizeValue from '../../utils/sanitizeValue';
import cacheActions from '../../actions/cacheActions';
import reportActions from '../../actions/reportActions';
import notificationActions from '../../containers/general/notification/NotificationsManager/actions';
import { getEntity } from '../../reducers/entitiesReducer';

import avatar from '../../assets/img/faces/marc.jpg';
import { getLoggedUserId } from 'reducers/sessionReducer';
import ciApi from 'services/ciApi';
import { store } from 'store';

class TasksReportView extends React.Component {
  state = {
    googleConnected: false
  };

  componentWillMount() {
    this.onMount();
  }

  onMount = () => {
    this.props.dispatch(cacheActions.cleanCache());
    this.fetchEntities().catch(this.onFetchFail);
    this.fetchGoogleStatus();
  };

  onFetchFail = apiResponse => this.props.dispatch(notificationActions.handleApiError(apiResponse));

  fetchEntities = () => this.props.dispatch(reportActions.tasks());

  getApiBaseUrl = () => {
    const host = process.env.REACT_APP_API_URL;
    const protocol = process.env.REACT_APP_API_PROTOCOL;
    const apiPath = process.env.REACT_APP_API_PATH || '';
    return `${protocol}://${host}${apiPath}`;
  };

  fetchGoogleStatus = async () => {
    try {
      const response = await ciApi.call({
        httpMethod: 'get',
        endpoint: '/google_oauth/status'
      });
  
      this.setState({
        googleConnected: response?.data?.googleConnected
      });
    } catch (error) {
      console.error('Erro ao buscar status do Google:', error);
    }
  };  

  renderGoogleAuthButton = () => {
    const { userId } = this.props;
    const { googleConnected } = this.state;
  
    const buttonBaseStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '10px 16px',
      backgroundColor: '#fff',
      color: '#5f6368',
      border: '1px solid #dadce0',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
      fontFamily: 'Roboto, sans-serif',
      boxShadow: 'none',
      textTransform: 'none',
      outline: 'none',
    };
  
    const logoStyle = {
      height: '18px',
      marginRight: '12px',
    };
  
    const handleDisconnect = async () => {
      if (!window.confirm('Deseja mesmo desconectar sua conta Google?')) return;
    
      try {
        await ciApi.call({
          httpMethod: 'get',
          endpoint: '/google_oauth/disconnect'
        });
    
        this.setState({ googleConnected: false });
    
        this.props.dispatch(notificationActions.showNotification('Conta google desvinculada. Complete a desvinculação no painel do google.', 'success'));
    
        window.open('https://myaccount.google.com/permissions', '_blank');
      } catch (error) {
        console.error('Erro ao desconectar Google:', error);
        this.props.dispatch(notificationActions.handleApiError('Erro ao desconectar conta Google.'));
      }
    };    
  
    const redirectUrl = `${this.getApiBaseUrl()}/google_oauth/redirect?user_id=${userId}`;
  
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '1rem',
        width: '100%'
      }}>
        {googleConnected ? (
          <button onClick={handleDisconnect} style={{ ...buttonBaseStyle, color: '#d9534f' }}>
            <img
              src="https://developers.google.com/identity/images/g-logo.png"
              alt="Google logo"
              style={logoStyle}
            />
            Desconectar Google Agenda
          </button>
        ) : (
          <a href={redirectUrl} style={{ textDecoration: 'none' }}>
            <button style={buttonBaseStyle}>
              <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google logo"
                style={logoStyle}
              />
              Conectar Google Agenda
            </button>
          </a>
        )}
      </div>
    );    
  };      

  render() {
    const { entity } = this.props;
    const funnelColors = ['#2E4B48', '#64B6AC', '#94ECBE', '#CEB477', '#D6C18F'];
    const funnelSizes = [12, 10, 8, 6, 4];

    return (
      <GridContainer>
        <ItemGrid xs={12} sm={12} md={12} lg={12} className="last">
          <HeaderCard
            cardTitle="Clientes"
            headerColor="orange"
            content={
              <>
                {this.renderGoogleAuthButton()}
                {entity && entity.funnel.map((item, index) => (
                  <FunnelItem
                    key={index}
                    title={item.name}
                    description={`Histórico: ${item.total} (últ. 6 meses)  • ${sanitizeValue('percentage', item.percentage)}`}
                    size={funnelSizes[index]}
                    customColor={{ background: funnelColors[index] }}
                  />
                ))}
              </>
            }
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={12} lg={12}>
          <HeaderCard
            cardTitle="Kanban"
            headerColor="orange"
            content={(
              <KanbanContainer content={
                entity && entity.kanban.map((column, index) => (
                  <KanbanColumn
                    key={index}
                    name={column.name}
                    content={
                    column.cards.map((card, index) => <KanbanCard client={card.client} task={card.task} columnName={column.name} />)
                  }
                  />
                ))
              }
              />
            )}
          />
        </ItemGrid>
      </GridContainer>
    );
  }
}


TasksReportView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  entity: PropTypes.object,
  userId: PropTypes.number,
};

const mapStateToProps = state => ({
  entity: getEntity('reports', 3)(state),
  userId: getLoggedUserId(state),
});

export default connect(mapStateToProps)(TasksReportView);
